import * as Yup from "yup";

export function initialValues() {
  return {
    email: "",
    role: "",
    sites: [],
    company: "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    email: Yup.string()
      .email(t("invalid_email") || "Email inválido")
      .required(t("required_field") || "Campo obligatorio"),
    role: Yup.string().required(t("required_field") || "Campo obligatorio"),
    sites: Yup.array().of(Yup.string()),
    company: Yup.string(),
  });
}
